var smsCommon =  require('./validate_sbid-ucs-common');
var inputAuxiliary = require('./input_auxiliary');
var errorMessage = require('./error_message');
var mainValidate =  require('./main_validate');



// WEBPACK FOOTER //
// ./src/shared/validate_sbid-ucs.js